import { Component, inject } from '@angular/core';
import { Upload } from '../../../core/models/upload.model';

import { ReferralPrescriberSpecialtyMappingService } from '../../../core/services/referral-prescriber-specialty-mapping.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { FormsModule } from '@angular/forms';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

const emptyForm = { file: null };

@Component({
    selector: 'app-capture-admin-import-referral-prescriber-specialty-mapping',
    templateUrl: './capture-admin-import-referral-prescriber-specialty-mapping.component.html',
    imports: [ImportNavComponent, FormsModule, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportReferralPrescriberSpecialtyMappingComponent {
  private referralPrescriberSpecialtyMappingService = inject(ReferralPrescriberSpecialtyMappingService);
  private router = inject(Router);

  uploading = false;
  formModel = { ...emptyForm };
  errors: string[] = [];

  get uploadButtonDisabled(): boolean {
    return !this.formModel.file;
  }

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.reset();
  }

  onUploadComplete(upload: Upload) {
    this.referralPrescriberSpecialtyMappingService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/referral-prescriber-specialty-mapping/history']);
        this.uploading = false;
        this.reset();
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError(_$event) {
    this.reset();
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  private reset() {
    this.uploading = false;
    this.formModel = { ...emptyForm };
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
